import { ProcessFileType } from '../convert/enums/process-file-type.enum';

/**
 * Source model input types gated by the "Allow others to download the
 * source model" project setting (allowSourceModelDownload).
 */
export const sourceBimFileTypes = [
  ProcessFileType.IFC,
  ProcessFileType.RVT,
  ProcessFileType.RFA,
  ProcessFileType.STEP,
  ProcessFileType.NWD,
  ProcessFileType.NWC,
  ProcessFileType.LAS,
  ProcessFileType.BIM,
  ProcessFileType.GLB,
  ProcessFileType.STL,
  ProcessFileType.OBJ,
  ProcessFileType.ZIP,
  ProcessFileType.MTL,
];
